import React from 'react'

import { ISurveyProgress, StepProgressBar } from 'components/onboardingWelcome'

const SurveyProgress = ({ currentStep, data: { title }, showProgressBar = true, steps }: ISurveyProgress) => {
  return (
    <>
      {showProgressBar ? (
        <div className='flex justify-center'>
          <StepProgressBar currentStep={currentStep} stepLabel={title} steps={steps} />
        </div>
      ) : null}
    </>
  )
}

export default SurveyProgress
